<template>
  <div class="mb-4">
    <HeaderFormItem
        :instruction="`${
                attribute.instruction ? attribute.instruction : ''
            } ${requiredasterisk}`"
        :description="`${
                attribute.description ? attribute.description : ''
            } `"
        :required="`${requiredmessage} `"
    >
    </HeaderFormItem>
    <div class="flex items-center w-full">
      <div class="flex-column w-full">
        <div class="mb-2 flex items-center">
          <i
              :class="
                            attribute.response_private == 1
                                ? 'fas fa-lock px-1 pb-2'
                                : ' '
                        "
          ></i>

          <label class="text-gray-700 text-base font-bold mb-2">
            {{ attribute.label ? attribute.label : '' }}
            {{ asterisk }}
          </label>
        </div>
        <select
            v-model="result"
            class="selectInput border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:border-blue-500"
            type="email"
            :placeholder="
                        attribute.config.placeholder
                            ? attribute.config.placeholder[this.$i18n.locale][0]
                            : ''
                    "
        >
          <option
              v-for="(option, index) in options"
              :key="index"
              :value="option"
          >
            {{ option }}
          </option>
        </select>
        <p class="text-gray-700 text-xs mb-2">
          {{ attribute.help ? attribute.help : '' }}
        </p>
      </div>
    </div>

    <b-field :message="message" type="is-danger font-bold text-center">
    </b-field>
  </div>
</template>

<script>
import FormItemMixin from '../FormItemMixin'
import HeaderFormItem from '../HeaderFormItem'

export default {
  name: 'SelectFormItem',
  components: {
    HeaderFormItem
  },
  mixins: [FormItemMixin],
  watch: {
    result: function (newValue) {
      this.saveUserAnswer({
        id: this.attribute.id,
        type_id: this.attribute.form_attribute_type_id,
        value: newValue
      })
    }
  },
  data: function () {
    return {
      options: []
    }
  },
  created() {
    this.getOptions()
  },
  methods: {
    getOptions() {
      this.options = this.attribute.config.options[this.$i18n.locale]
    }
  }
}
</script>
